import { render, staticRenderFns } from "./DoctorsList.vue?vue&type=template&id=0d40eba6&scoped=true&"
import script from "./DoctorsList.vue?vue&type=script&lang=js&"
export * from "./DoctorsList.vue?vue&type=script&lang=js&"
import style0 from "./DoctorsList.vue?vue&type=style&index=0&id=0d40eba6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d40eba6",
  null
  
)

export default component.exports